module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Light.466b3dd9.woff2";